import React from 'react';
import { BadgeCheck, Recycle, Sparkles, ShieldCheck } from 'lucide-react';

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-6 md:px-10 py-16" data-testid="about-page">
      <span className="overline text-accent">Our Story</span>
      <h1 className="font-display text-5xl sm:text-7xl mt-3 tracking-tight max-w-4xl leading-[0.95]">
        A new way to buy, sell, and reimagine luxury.
      </h1>
      <p className="mt-10 max-w-2xl font-light text-lg leading-relaxed text-muted-foreground">
        JJBSTYLISH is the world's largest curator of authenticated luxury resale. We believe that the most beautiful objects are made to be lived in — and lived in again. Every piece in our collection is inspected by our team of expert gemologists, horologists, and brand specialists.
      </p>

      <section id="authentication" className="mt-32 grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
        <div>
          <BadgeCheck size={32} strokeWidth={1.2} className="text-accent" />
          <h2 className="font-display text-4xl mt-6">Authentication, Always.</h2>
          <p className="mt-6 font-light leading-relaxed text-muted-foreground">Every item that enters our warehouse passes through a rigorous, multi-point inspection. Our specialists examine craftsmanship, materials, hardware, stitching, serial numbers, and provenance — refusing anything that doesn't measure up.</p>
        </div>
        <img src="https://images.pexels.com/photos/37793325/pexels-photo-37793325.jpeg" alt="Authentication" className="w-full aspect-[5/4] object-cover" />
      </section>

      <section className="mt-32 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-b border-border py-16">
        {[
          { i: ShieldCheck, t: '200+ Experts', s: 'Brand authenticators in-house' },
          { i: Sparkles, t: '2M+ Items', s: 'Authenticated to date' },
          { i: Recycle, t: '85% Comm.', s: 'Industry-leading consignor payout' },
          { i: BadgeCheck, t: '14 Days', s: 'Average sale time' },
        ].map((x, i) => (
          <div key={i}>
            <x.i size={24} strokeWidth={1.2} className="text-accent" />
            <div className="font-display text-3xl mt-4">{x.t}</div>
            <div className="overline text-muted-foreground mt-2">{x.s}</div>
          </div>
        ))}
      </section>

      <section id="contact" className="mt-32 grid grid-cols-1 md:grid-cols-2 gap-16">
        <div>
          <h2 className="font-display text-4xl">Get in Touch</h2>
          <p className="mt-4 font-light text-muted-foreground">Our concierge team is available 7 days a week.</p>
          <ul className="mt-10 space-y-4 font-light">
            <li><span className="overline text-muted-foreground block">Email</span> concierge@luxeconsign.com</li>
            <li><span className="overline text-muted-foreground block">Phone</span> +1 (888) 555-JJBS</li>
            <li><span className="overline text-muted-foreground block">Hours</span> Mon–Sun · 9am – 10pm ET</li>
          </ul>
        </div>
        <div>
          <h2 className="font-display text-4xl">FAQ</h2>
          <div className="mt-8 space-y-6">
            {[
              { q: 'How does authentication work?', a: 'Every item passes through our 30-point inspection process before being listed.' },
              { q: 'What is your commission?', a: 'Sellers earn up to 85% commission depending on item value and category.' },
              { q: 'Do you ship internationally?', a: 'Yes — we ship insured to over 60 countries with white-glove service.' },
              { q: 'What is your return policy?', a: '14-day returns on most items. Final-sale items are clearly marked.' },
            ].map((f, i) => (
              <div key={i} className="border-b border-border pb-4">
                <div className="font-display text-lg">{f.q}</div>
                <p className="mt-2 text-sm font-light text-muted-foreground">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
